export const USER_EMPTY_OPERATORS = {
	UNASSIGNED: 'UNASSIGNED',
	EMPTY: 'EMPTY',
};
